import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
// styles.css is linked directly from index.html (and copied verbatim by
// build.mjs) rather than imported here, so there is exactly one stylesheet
// output instead of both a bundled app.css and a copied styles.css.

const container = document.getElementById("root")!;
createRoot(container).render(<App />);
